"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferencesService = void 0;
const api_1 = require("./api");
const PATH = '/profile/api/preferences';
const PATH_V2 = '/profile/api/v2/preferences';
class PreferencesService {
    static async fetch(uid) {
        try {
            return await api_1.API.get({
                url: `${PATH}/by-login/${uid}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async save(uid, preferences) {
        try {
            return await api_1.API.post({
                url: `${PATH}/by-login/${uid}`,
                body: preferences
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async savePreferences(preferences) {
        try {
            return await api_1.API.post({
                url: `${PATH_V2}/by-login`,
                body: preferences
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async fetchOptions() {
        try {
            return await api_1.API.get({
                url: '/profile/api/message-category-values'
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.PreferencesService = PreferencesService;
//# sourceMappingURL=preference-service.js.map